var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpdate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 3,
  x: 5,
  y: 19,
  fill: "currentColor",
  rx: 0.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 3,
  x: 18,
  y: 19,
  fill: "currentColor",
  rx: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm-8 2.5a.5.5 0 0 0-.5.5v2l.003.031a4 4 0 0 0-3.074 5.77L6.7 16.1a.5.5 0 0 0 .6.8l1.69-1.268A4 4 0 0 0 12 17c1.2 0 2.277-.53 3.01-1.368L16.7 16.9a.5.5 0 0 0 .6-.8l-1.73-1.298a4 4 0 0 0-3.074-5.77q.002-.016.004-.032V7a.5.5 0 0 0-.5-.5m0 3.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
})));
export default SvgUpdate;